import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { SidebarContext } from 'context/SidebarContext';
import AgentsServices from 'services/AgentsServices';
import { notifyError, notifySuccess } from 'utils/toast';

const useAgentsSubmit = (id) => {
	const {
		isDrawerOpen,
		closeDrawer,
		setIsUpdate,
		selectedAgentsValue,
		setSelectedAgentsValue,
		setSelectedCompanyValue,
		selectedCompanyValue,
		fleetContent,
		setFleetContent,
		companyContent,
		setCompanyContent,
	} = useContext(SidebarContext);
	const [selectedYear, setSelectedYear] = useState(null);
	const [step, setStep] = useState(1);
	const [idProofUrl, setIDProofUrl] = useState([]);
	const [panUrl, setPanUrl] = useState([]);
	const [gstUrl, setGstUrl] = useState([]);
	const [rcUrl, setRcUrl] = useState([]);
	const [logoUrl, setLogoUrl] = useState([]);
	const [checkLeafUrl, setCheckLeafUrl] = useState([]);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [selectedState, setSelectedState] = useState(null);
	const [selectedCity, setSelectedCity] = useState(null);
	const [selectedCountryId, setSelectedCountryId] = useState(null);
	const [selectedCompanyType, setSelectedCompanyType] = useState(1);
	const [selectedTitle, setselectedTitle] = useState('');
	const [selectedCountryCode, setSelectedCountrycode] = useState('');
	const [selectedRole, setselectedRole] = useState('');
	const [selectedTransHead, setSelectedTransHead] = useState('');
	const [seller, setSeller] = useState('');
	const [selectedRadioValueGender, setSelectedRadioValueGender] = useState('');
	const [selectedFleetTypeValue, setSelectedFleetTypeValue] = useState('');
	const [loading, setLoading] = useState(false);
	const [selectedCompanyTypeName, setSelecetedCompanyTypeName] = useState('');
	const [agentType,setAgentType]=useState('');
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const id_employee = adminInfo?.id ? adminInfo.id : 0;
	const {
		register,
		handleSubmit,
		setValue,
		clearErrors,
		trigger,
		formState: { errors },
	} = useForm();
	const handleYearChange = (date) => {
		setSelectedYear(date);
	};

	const handleCountryChange = (country_code, country_id) => {
		setSelectedCountryId(country_id);
		setSelectedCountrycode(country_code);
	};
	const handleStateChange = (state_id) => {
		setSelectedState(state_id);
	};
	const handleCityChange = (city_id) => {
		setSelectedCity(city_id);
	};
	const handleChangeAgentsType = (value) => {
		// setSelectedAgentsValue(value);

		if (value === 'Fleet' && selectedCompanyValue === 'Company') {
			setCompanyContent(1);
			setFleetContent(1);
		} else if (value === 'Fleet' && selectedCompanyValue === 'Non-Company') {
			setCompanyContent(0);
			setFleetContent(1);
		} else {
			setCompanyContent(0);
			setFleetContent(0);
		}
	};

	const handleNextStep = async () => {
		await Promise.all([validateForm()]);
		if (Object.keys(errors).length === 0) {
			if (step !== 3) {
				setStep(step + 1);
			} else {
				handleSubmit(onSubmit);
			}
		} else {
			return notifyError(`Please provide all the Details`);
		}
	};
	const handlePreviousStep = async () => {
		setStep(step - 1);
	};
	const goToStep = async (stepNumber) => {
		await Promise.all([validateForm()]);
		if (Object.keys(errors).length === 0) {
			setStep(stepNumber);
		} else {
			return notifyError(`Please provide all the Details`);
		}
	};
	const validateForm = async () => {
		await trigger();

		return Object.keys(errors).length;
	};

	const onSubmit = async (data) => {
		//selectedCompanyTypeName.trim().toLowerCase().replace(/\s+/g, "") !== "noncompany" &&
		if (!panUrl) {
			notifyError('Pan image is required');
			return;
		}
		setLoading(true);
		try {
			if (panUrl) {
				const partsAgentsPan = panUrl.split('/');
				const filename_AgentsPan =
					partsAgentsPan[partsAgentsPan.length - 2] +
					'/' +
					partsAgentsPan[partsAgentsPan.length - 1];
				data.pan_front_side_img = filename_AgentsPan;
			}

			if (gstUrl) {
				const partsGst = gstUrl.split('/');
				const filename_gst =
					partsGst[partsGst.length - 2] + '/' + partsGst[partsGst.length - 1];
				data.gst_front_side_img = filename_gst;
			}

			if (rcUrl) {
				const partsRc = rcUrl.split('/');
				const filename_rc =
					partsRc[partsRc.length - 2] + '/' + partsRc[partsRc.length - 1];
				data.company_reg_cer_img = filename_rc;
			}

			if (logoUrl) {
				const partsLogo = logoUrl.split('/');
				const filename_logo =
					partsLogo[partsLogo.length - 2] +
					'/' +
					partsLogo[partsLogo.length - 1];
				data.company_logo = filename_logo;
			}

			data.added_by = id_employee;
			
			data.country = 110;
			data.state = Number(selectedState);
			data.city = Number(selectedCity);
			data.type_of_company = Number(selectedCompanyType);
			data.transport_head_id = Number(data.transport_head_id);
			data.seller = Number(data.seller);
			setIsSubmitting(true);
			if (id) {
				data.agent_type = agentType;
				const res = await AgentsServices.updateAgents(id, data);
				setIsUpdate(true);
				setIsSubmitting(false);
				notifySuccess(res.message);
				closeDrawer();
			} else {
				data.agent_type = "Offline";
				const res = await AgentsServices.addAgents(data);
				setIsUpdate(true);
				setIsSubmitting(false);
				notifySuccess(res.message);
				closeDrawer();
			}
		} catch (err) {
			notifyError(err ? err?.response?.data?.message : err.message);
			setIsSubmitting(false);
			//closeDrawer();
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (id) {
			(async () => {
				try {
					const res = await AgentsServices.getAgentsById(id);
// console.log(res)
					if (res) {
						setAgentType(res.agent_type)
						setValue('name', res.name);
						setValue('email_id', res.email_id);
						setValue('mobile_no', res.mobile_no);
						setValue('al_mobile_no', res.al_mobile_no);
						setValue('company_name', res.company_name);
						setValue('address', res.address);
						setValue('pincode', res.pincode);
						setValue('pan_no', res.pan_no);
						setPanUrl(res.pan_front_side_img);
						setValue('gst_no', res.gst_no);
						setGstUrl(
							res.gst_front_side_img !== 'undefined/' ||
								res.gst_front_side_img !== null
								? res.gst_front_side_img
								: null
						);
						setRcUrl(res.company_reg_cer_img);
						setLogoUrl(res.company_logo);
						setSelectedCity(res.city);
						setSelectedState(res.state);
						setSelectedCountryId(res.country);
						setSelectedCompanyType(res.type_of_company);
						setValue('type_of_company', res.type_of_company);
						setselectedTitle(res.name_title);
						setSelectedTransHead(res.transport_head_id);
						setSeller(res.seller_id);
						setValue('transport_head_id', res.transport_head_id);
						setValue('seller', res.seller_id);
					}
				} catch (err) {
					notifyError(err ? err?.response?.data?.message : err.message);
				}
			})();
		} else {
				setValue('name');
				setValue('email_id');
				setValue('mobile_no');
				setValue('al_mobile_no');
				setValue('company_name');
				setValue('address');
				setValue('pincode');
				setValue('pan_no');
				setValue('transport_head_id');
				setValue('seller');
				setPanUrl('');
				setValue('gst_no');
				setGstUrl('');
				setRcUrl('');
				setLogoUrl('');
				setStep(1);
				setSelectedCity(null);
				setSelectedState(null);
				setSelectedCountryId(null);
				setSelectedTransHead("");
				setSeller("");
		}
		if (!isDrawerOpen) {
			setTimeout(() => {
				setValue('name');
				setValue('email_id');
				setValue('mobile_no');
				setValue('al_mobile_no');
				setValue('company_name');
				setValue('address');
				setValue('pincode');
				setValue('pan_no');
				setValue('transport_head_id');
				setSelectedTransHead('');
				setSeller("");
				setValue('seller');
				setPanUrl('');
				setValue('gst_no');
				setGstUrl('');
				setRcUrl('');
				setLogoUrl('');
				setStep(1);
				setSelectedCity(null);
				setSelectedState(null);
				setSelectedCountryId(null);
				setAgentType('')
			}, 200);

			clearErrors();

			return;
		}
	}, [id, isDrawerOpen, setValue, clearErrors]);

	return {
		trigger,
		register,
		handleSubmit,
		onSubmit,
		errors,
		handleNextStep,
		step,
		setStep,
		handlePreviousStep,
		goToStep,
		setSelectedRadioValueGender,
		setSelectedCompanyValue,
		setSelectedCity,
		setSelectedState,
		setSelectedCountryId,
		setSelectedCompanyType,
		setSelectedAgentsValue,
		setSelectedFleetTypeValue,
		setSelectedCountrycode,
		setCheckLeafUrl,
		setPanUrl,
		setRcUrl,
		setLogoUrl,
		setIDProofUrl,
		setGstUrl,
		idProofUrl,
		panUrl,
		gstUrl,
		rcUrl,
		logoUrl,
		checkLeafUrl,
		isSubmitting,
		selectedCompanyValue,
		selectedCity,
		selectedState,
		selectedCountryId,
		setLoading,
		loading,
		selectedRole,
		selectedCountryCode,
		selectedAgentsValue,
		selectedFleetTypeValue,
		selectedRadioValueGender,
		selectedCompanyType,
		selectedTransHead,
		setSelectedTransHead,
		handleChangeAgentsType,
		handleCityChange,
		handleCountryChange,
		handleStateChange,
		fleetContent,
		companyContent,
		setselectedRole,
		selectedTitle,
		setselectedTitle,
		handleYearChange,
		selectedYear,
		seller,
		setSeller,
		selectedCompanyTypeName,
		setSelecetedCompanyTypeName,
		setValue,
		agentType
	};
};

export default useAgentsSubmit;
